import http from "./http";

/* =========================
   GET FOLLOWUPS (GENERIC)
========================= */
export const getFollowupsWithParams = async (params = {}) => {
  try {
    const res = await http.get("/followups_report", { params });
    return res.data;
  } catch (error) {
    console.error("Followups API Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};